import React, { useState } from 'react';
import { useTrans } from 'base/utils/i18n';
import styles from './index.module.less';
import { IAddress } from 'base/interfaces/address';

type IProps = {
    address: IAddress
}

const ResultsAddressForm: React.FC<IProps> = (props) => {
    const { address } = props
    const [modalState, setModalState] = useState<{
        visible: boolean;
        title?: string;
    }>({ visible: false });

    const { t } = useTrans();


    return (
        <div>
            <h3 className={styles.title}>You entered</h3>
            <div className={styles['address-wrap']}>
                <p className={styles.address}>
                    <span className={styles.name}>{address?.firstName} {address?.lastName} </span>
                    <span className={styles.phone}>{address?.mobile}</span>
                </p>
                <p className={styles.address}>
                    {address?.address1} {address?.address2}
                </p>
                <p className={styles.address}>
                    {address?.cityText} {address?.provinceText} {address?.countryText} {address?.zipcode}
                </p>
            </div>
        </div>
    );
};

export default ResultsAddressForm